import {
  createEntityAdapter,
  createSlice,
  type EntityState,
  type PayloadAction,
} from "@reduxjs/toolkit";

export interface BootstrapDataStatusType {
  isLoading: boolean;
  isDataFetched: boolean;
  isContractExpired: boolean;
  havingError: boolean;
  errorMessage: boolean;
}

const initialState = {
  isLoading: true,
  isDataFetched: false,
  isContractExpired: false,
  havingError: false,
  errorMessage: "",
};

export const bootstrapDataStatusSlice = createSlice({
  name: "bootstrapDataStatus",
  initialState,
  reducers: {
    setBootstrapDataStatus: (state, action: PayloadAction<any[]>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setBootstrapDataStatus } = bootstrapDataStatusSlice.actions;

export default bootstrapDataStatusSlice.reducer;
